<div [@preLoader] class="app-preloader" *ngIf="showLoader">
  <div class="new-loader css-trickss">
    <img src="assets/img/loaders/preloader.gif" alt="pre-loader" />
  </div>
</div>